import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Box } from '@mui/material';
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material';
import { Selection, NumberFormatCustom } from 'components';

const InputItem = React.forwardRef(
  (
    {
      item,
      index,
      onDelete,
      setValues,
      disabledResponseCheck,
      widthContainerLeft = '45%',
      widthContainerBody = '65%',
      subFeeList,
      unitList,
    },
    ref,
  ) => {
    const [arrFeeGroup, setArrFeeGroup] = React.useState([]);
    const [setNameFeeGroup, setSetNameFeeGroup] = React.useState('');
    const [unitCode, setUnitCode] = React.useState('');
    const [requestPrice, setRequestPrice] = React.useState(0);
    const [quantity, setQuantity] = React.useState(0);

    React.useImperativeHandle(ref, () => ({
      getAlert() {
        alert('getAlert from Child');
      },
    }));
    React.useEffect(() => {
      setArrFeeGroup(item?.arrFeeGroup || []);
      setRequestPrice(item?.requestPrice);
      setQuantity(item?.quantity);
      setUnitCode(item?.unitCode || '');
    }, [item]);

    React.useEffect(() => {
      if (arrFeeGroup && arrFeeGroup.length > 0) {
        const nameFeeGroup = arrFeeGroup
          ?.map((item) => {
            const name = subFeeList.find((i) => i.id === item)?.name;
            return name;
          })
          .join(', ');
        setSetNameFeeGroup(nameFeeGroup);
      } else {
        setSetNameFeeGroup('');
      }
    }, [subFeeList, arrFeeGroup]);

    React.useEffect(() => {
      if (arrFeeGroup && arrFeeGroup.length > 0) {
        const nameFeeGroup = arrFeeGroup
          .map((item) => {
            const name = subFeeList.find((i) => i.id === item)?.name;
            return name;
          })
          .join(', ');
        setSetNameFeeGroup(nameFeeGroup);
      } else {
        setSetNameFeeGroup('');
      }
    }, [arrFeeGroup]);

    const onChangeFeeGroup = React.useCallback(
      (e) => {
        setArrFeeGroup(e.target.value);
        setValues((prev) => {
          prev[index].arrFeeGroup = e.target.value;
          return [...prev];
        });
      },
      [arrFeeGroup],
    );

    const onChangeRequestPrice = React.useCallback(
      (e) => {
        setRequestPrice(e.target.value);
        setValues((prev) => {
          prev[index].requestPrice = +e.target.value;
          return [...prev];
        });
      },
      [requestPrice],
    );
    const onChangeQuantity = React.useCallback(
      (e) => {
        setQuantity(e.target.value);
        setValues((prev) => {
          prev[index].quantity = +e.target.value;
          return [...prev];
        });
      },
      [quantity],
    );
    const onChangeUnit = React.useCallback(
      (e) => {
        setUnitCode(e.target.value);
        setValues((prev) => {
          prev[index].unitCode = e.target.value;
          return [...prev];
        });
      },
      [unitCode],
    );

    return (
      <>
        <Box>
          <i style={{ color: 'blue' }}>
            Giá bán request bao gồm: Giá cước{setNameFeeGroup && `, ${setNameFeeGroup}`}
          </i>
        </Box>
        <Container>
          <ContainerLeft width={widthContainerLeft}>
            <Selection
              sx={{
                width: '100%',
                marginTop: 0,
                fontSize: '12px',
              }}
              sxInput={{ padding: '0px', margin: '0px' }}
              label="Giá request"
              name="arrFeeGroup"
              multiple={true}
              onChange={onChangeFeeGroup}
              value={arrFeeGroup}
              fieldValue="id"
              fieldView="name"
              dataArrObject={subFeeList}
              disabled={disabledResponseCheck}
            />
          </ContainerLeft>
          <ContainerBody width={widthContainerBody}>
            <StyledTextField
              label="Giá Request"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangeRequestPrice}
              value={requestPrice}
              disabled={disabledResponseCheck}
            />
            <StyledTextField
              label="Số lượng"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangeQuantity}
              value={quantity}
              disabled={disabledResponseCheck}
            />
            <Box sx={{ width: '100%', marginLeft: '10px', marginRight: '10px' }}>
              <Selection
                sx={{
                  width: '100%',
                  marginTop: 0,
                  fontSize: '12px',
                }}
                sxInput={{ padding: '0px', margin: '0px' }}
                label="Đơn vị tính"
                name="serviceId"
                onChange={onChangeUnit}
                value={unitCode}
                fieldValue="code"
                fieldView="name"
                dataArrObject={unitList}
                disabled={disabledResponseCheck}
              />
            </Box>
          </ContainerBody>
          {!disabledResponseCheck && (
            <ContainerAction>
              <ButtonWrapper onClick={() => onDelete(index)} sx={{ borderColor: 'error.main' }}>
                <HighlightOffIcon sx={{ color: 'error.main' }} />
              </ButtonWrapper>
            </ContainerAction>
          )}
        </Container>
      </>
    );
  },
);
export default InputItem;

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '50%',
  marginLeft: '10px',
}));
const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '5px',
}));
const ContainerBody = styled(Box)(({ theme, width = '45%' }) => ({
  width: width,
  display: 'flex',
  flexDirection: 'row',
}));
const ContainerLeft = styled(Box)(({ theme, width = '15%' }) => ({
  width: width,
  display: 'flex',
  flexDirection: 'row',
}));
const ContainerAction = styled(Box)(({ theme }) => ({
  width: '5%',
  display: 'flex',
  flexDirection: 'row',
}));
const ButtonWrapper = styled(Box)(({ theme, disabled = false }) => ({
  pointerEvents: disabled ? 'none' : 'all',
  paddingInline: '6px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '0 4px 4px 0',
}));
